import { useDeletePartySupMast } from "http-hooks/partysupmast/usepartysupmast";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteGLAccount({ id, onClose }) {
  const { mutateAsync, isPending } = useDeletePartySupMast();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete GL Account"
      description="Are you sure you want to delete this GL Account? This account will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
} 